<template>
  <custom-dialog
    :show="show"
    :title="title"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="500"
  >
    <div class="flex form" slot="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="98px"
        label-position="right"
        size="mini"
      >
        <el-form-item label="账号" prop="account">
          <el-input
            v-model="form.account"
            :disabled="rowInfo.id ? true : false"
          ></el-input>
        </el-form-item>
        <!-- <template v-if="!rowInfo.id"> -->
        <el-form-item label="密码" prop="pwd">
          <el-input show-password v-model="form.pwd"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="surePwd">
          <el-input show-password v-model="form.surePwd"></el-input>
        </el-form-item>
        <!-- </template> -->
        <el-form-item label="用户名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="机构" prop="org">
          <el-select v-model="form.org" popper-class="orgId">
            <el-option ref="user" :value="form.org" style="height: auto">
              <el-tree
                ref="userTree"
                :data="orgData"
                show-checkbox
                style="font-weight: 400; pointer-events: auto"
                node-key="id"
                :check-strictly="true"
                default-expand-all
                :props="defaultProps"
                @check="handleCheckChange"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="form.role">
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" style="height: 100%" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="save">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>
  
  <script>
import { addUser, editUser, roleList } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orgData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    // 校验账号
    var validateAcc = (rule, value, callback) => {
      const regex = /^[a-zA-Z0-9]+$/;
      if (!regex.test(value)) {
        callback(new Error("账号只能为英文或者数字"));
      } else {
        callback();
      }
    };
    // 校验密码
    var validatePass = (rule, value, callback) => {
      const regex = /^(?![\d]+$)(?![a-z]+$)(?![A-Z]+$)[\da-zA-z]{8,16}$/;
      if (!regex.test(value)) {
        callback(new Error("至少含2种或以上字符类型"));
      } else {
        callback();
      }
    };
    var validatePwdSure = (rule, value, callback) => {
      if (value !== this.form.pwd) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      roleOptions: [],
      checkKeys: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
        // children: "children",
        // label: (data, node) => {
        //   return data.name;
        // },
        // isLeaf: (data, node) => {
        //   if (typeof data.leaf !== "undefined") {
        //     return data.leaf;
        //   } else {
        //     return true;
        //   }
        // },
      },
      form: {
        account: "",
        pwd: "",
        surePwd: "",
        name: "",
        org: "",
        role: "",
        orgCode: [],
      },
      rules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            validator: validateAcc,
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        surePwd: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            validator: validatePwdSure,
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        org: [{ required: true, message: "请选择机构", trigger: "blur" }],
        role: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
    };
  },
  computed: {
    title() {
      if (this.rowInfo.id) {
        // 编辑
        return "编辑用户";
      } else {
        // 新增
        return "新增用户";
      }
    },
    currentFormItem() {
      return this.formItem;
    },
  },
  watch: {
    show: {
      handler(val) {
        if(val){
          this.getRoleList();
        }
      },
      deep: true,
    },
    rowInfo: {
      handler(val) {
        // console.log(val, "vvvv");
        if (val.id) {
          this.form = {
            account: val.account,
            // pwd: val.,
            // surePwd: val.,
            name: val.role,
            org: val.org,
            role: val.roleId,
            orgCode: val.orgId.split(","),
          };
          this.checkKeys = val.orgId.split(",")
          this.checkKeysNode(this.checkKeys)
        }
      },
      deep: true
    },
    "form.keyword": {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.menuTree.filter(newV);
        });
      },
      // deep: true,
    },
  },
  mounted() {
    // this.getRoleList();
  },
  methods: {
    checkKeysNode(node){
      this.$nextTick(()=>{
        this.$refs.userTree.setCheckedKeys(node) // 勾选默认节点
      })
    },
    getRoleList() {
      roleList({
        page_size: 2000,
        page_num: 1,
      }).then((res) => {
        this.roleOptions = res.data.infos.map((item) => {
          return {
            value: item.role_id,
            label: item.name,
          };
        });
        // console.log(this.roleList, "ffffffff");
      });
    },
    handleCheckChange(data, e, l) {
      console.log(e, l, "ddddddd"); // 可以拿到节点信息
      this.form.orgCode = e.checkedKeys
      this.form.org = "";
      e.checkedNodes.map((item) => {
          this.form.org = this.form.org + item.label + " ";
      });
    },
    // filterMenu(e) {
    //   console.log(e, "ee");
    //   this.$nextTick(() => {
    //     this.$refs.menuTree.filter(e);
    //   });
    // },
    // filterNode(value, data) {
    //   // 筛选节点
    //   if (!value) return true;
    //   return data.label.indexOf(value) !== -1;
    // },
    handleClose(done) {
      this.$emit("update:rowInfo", {})
      this.$emit("update:show", false);
      // this.$refs.form.clearValidate();
      this.form = {
        account: "",
        pwd: "",
        surePwd: "",
        name: "",
        org: "",
        role: "",
        orgCode: [],
      };
    },
    save() {
      // console.log(this.form, "fffffffff")
      this.$refs.form.validate((valid) => {
        if (valid) {
          let param = {
            name: this.form.name,
            org_id: this.form.orgCode,
            role_id: this.form.role,
            account: this.form.account,
            pwd: this.form.pwd,
          };
          // 此处判断新增还是编辑
          //   let cusFunc =
          if (this.rowInfo.id) {
            // 编辑
            param.user_id = this.rowInfo.id;
            editUser(param).then((res) => {
              if (res.code == 200) {
                if (res.code == 200) {
                  this.$message.success("用户信息编辑成功");
                } else {
                  this.$message.error(res.msg);
                }
                this.$emit("refush")
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            // 新增
            // param.account = this.form.account;
            param.pwd = this.form.pwd;
            addUser(param).then((res) => {
              if (res.code == 200) {
                this.$message.success("用户信息新增成功");
              } else {
                this.$message.error(res.msg);
              }
              this.handleClose();
              this.$emit("refush")
            });
          }
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;

  ::v-deep .el-form-item__label {
    font-weight: bold;
  }
}
</style>